import { api } from './client.js'

export function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

const savedName = (headers, fallback) => {
  const match = /filename\*=UTF-8''([^;]+)/.exec(headers['content-disposition'] || '')
  return match ? decodeURIComponent(match[1]) : fallback
}

export async function downloadFile(file, artifact = 'original') {
  const res = await api.get(`/api/files/${file.id}/download`, { params: artifact === 'original' ? {} : { artifact }, responseType: 'blob' })
  saveBlob(res.data, savedName(res.headers, file.name || `${artifact}.pdf`))
}

export async function downloadRedactionPackage(file) {
  const res = await api.get(`/api/files/${file.id}/redaction-package`, { responseType: 'blob' })
  saveBlob(res.data, savedName(res.headers, `${file.name || 'document'} — redaction package.zip`))
}
